import { compose, hoistStatics, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Blog from './Blog';
import WithLoading from '../../../../components/WithLoading';
import BlogPostService from '../../../../services/blogPost.service';
import BlogPostCategoriesService from '../../../../services/blogPostCategories.service';
import ModuleService from '../../../../services/module.service';

const callbackToSetSearch = props => async (value) => {
  const { criteria, setPosts, setCount, setCriteria } = props;
  const { data, count } = await BlogPostService.getData({ ...criteria, search: value, page: 0 });
  setCriteria({ ...criteria, search: value, page: 0 });
  setPosts(data);
  setCount(count);
};

const goToPage = props => async (nextPage) => {
  const { criteria, setCriteria, setPosts, setCount } = props;
  const page = nextPage > -1 ? nextPage : 0;
  const newCriteria = { ...criteria, };
  if (criteria.category_id.includes(-1)) {
    newCriteria.category_id = criteria.category_id.map(catId => catId === -1 ? 'null' : catId);
  }
  if (page) {
    window.history.replaceState(null, null, `/blog?page=${page + 1}`);
  } else { window.history.replaceState(null, null, '/blog'); }

  const { data, count } = await BlogPostService.getData({ ...newCriteria, page });
  setPosts(data);
  setCount(count);
  setCriteria({ ...criteria, page });
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const loadMoreCategories = props => async (nextPage) => {
  const {
    isLoad,
    setHasMore,
    categories,
    criteriaCat,
    setCategories,
    setCriteriaCat,
    categoriesCount,
    setCategoriesCount,
  } = props;
  if (!isLoad) {
    const page = nextPage > -1 ? nextPage : 0;
    if (criteriaCat.limit * (page + 1) >= categoriesCount) setHasMore(false);
    const { data, count } = await BlogPostCategoriesService.getData({ ...criteriaCat, page });
    setCategories([...categories, ...data]);
    setCategoriesCount(count);
    setCriteriaCat({ ...criteriaCat, page });
  }
};

const preLoad = async (props) => {
  const { setIsLoad, criteriaCat, setCategories, setCategoriesCount, setHasMore } = props;
  setIsLoad(true);
  const { data, count } = await BlogPostCategoriesService.getData({ ...criteriaCat, page: 0 });
  setCategories(data);
  setCategoriesCount(count);
  setHasMore(criteriaCat.limit < count);
  setIsLoad(false);
};

const chooseCat = props => (e, cat) => {
  e.preventDefault();
  const { timer, setTimer, checked } = props;
  clearTimeout(timer);
  const newChecked = { ...checked,
    [cat.id]: checked[cat.id] !== undefined ? !checked[cat.id] : true };
  props.setChecked(newChecked);
  const categories = Object.keys(newChecked)
    .filter(key => (newChecked[key] !== false))
    .map(key => parseInt(key, 10));
  const newTimer = setTimeout(() => {
    goToPage({ ...props,
      criteria: { ...props.criteria, category_id: categories } })(0);
  }, 500);
  setTimer(newTimer);
};

const updateChecked = props => (index, value) => {
  props.setChecked({ ...props.checked, [index]: value });
};


const defaultCriteria = {
  page: 0,
  limit: 5,
  sortBy: 'created_at',
  order: 'desc',
  category_id: '',
};

const defaultCriteriaCat = {
  page: 0,
  limit: 10,
  sortBy: 'created_at',
  order: 'desc',
};

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
});

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('timer', 'setTimer', null),
  withState('isLoading', 'setIsLoading', true),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('count', 'setCount', 0),
  withState('posts', 'setPosts', []),
  withState('lastPosts', 'setLastPosts', []),
  withState('categories', 'setCategories', []),
  withState('criteriaCat', 'setCriteriaCat', defaultCriteriaCat),
  withState('hasMore', 'setHasMore', true),
  withState('isLoad', 'setIsLoad', true),
  withState('categoriesCount', 'setCategoriesCount', 0),
  withState('checked', 'setChecked', {}),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading, setCount, criteria, setPosts, setLastPosts, setCriteria } = this.props;
      const queryInd = window.location.href.indexOf('=');
      let startPage = 0;
      if (queryInd !== -1) {
        startPage = parseInt(window.location.href.slice(queryInd + 1), 10) - 1;
      }
      const { data, count } = await BlogPostService.getData({ ...criteria, page: startPage });
      await setPosts(data);
      await setCount(count);
      setCriteria({ ...criteria, page: startPage });
      const lastPosts = await BlogPostService.getData({
        limit: 10,
        sortBy: 'created_at',
        order: 'desc' });
      setLastPosts(lastPosts.data);
      await preLoad(this.props);
      setIsLoading(false);
    },
  }),
  withProps(props => ({
    backgroundColor: props.modulesSettings[ModuleService.TYPE_BLOG].color ?
      props.modulesSettings[ModuleService.TYPE_BLOG].color : props.modulesSettings[ModuleService.TYPE_BLOG].default_color ?
        props.modulesSettings[ModuleService.TYPE_BLOG].default_color : 'banner boxs bannerblue2gdnt bannerother',
  })),
  withHandlers({
    goToPage,
    chooseCat,
    updateChecked,
    loadMoreCategories,
    callbackToSetSearch,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Blog)));



// WEBPACK FOOTER //
// ./src/views/modules/blog/blogs/index.js